import type { Arealplan, ArealplanDomains } from '@origo/planregister';
import { domainLabel } from '@origo/planregister';
import type { PlanSummary, PlanBadge } from '../types';
import { formatDateNb } from './formatDate';

/** Fargevariant for planstatus-badge. Ren UI-logikk (ikke i tjenestens domene). */
function planstatusVariant(code: string): PlanBadge['variant'] {
    switch (code) {
        case '3': // Endelig vedtatt
        case '6': // Vedtatt med utsatt rettsvirkning
        case '7': // Endelig vedtatt med tidsbegrensning
            return 'success';
        case '4': // Opphevet
        case '5': // Utgått/erstattet
            return 'danger';
        case '1': // Planlegging igangsatt
        case '2': // Planforslag
            return 'info';
        default:
            return 'default';
    }
}

/**
 * Mapper en Arealplan til kort-visning. Badge-tekster hentes fra tjenestens
 * coded value domains (faller tilbake til rå kode hvis domenet ikke er lastet).
 */
export function toPlanSummary(plan: Arealplan, domains?: ArealplanDomains): PlanSummary {
    return {
        nasjonalArealplanId: plan.nasjonalArealplanId,
        plannavn: plan.plannavn,
        sistEndret: formatDateNb(plan.vedtaksdato ?? plan.ikrafttredelsesdato),
        // sistEndretAv + omraderCount er ikke i domain — skjules i kortet (UI tåler undefined)
        sistEndretAv: undefined,
        omraderCount: undefined,
        badges: [
            { label: domainLabel(domains, 'plantype', plan.plantype), variant: 'info' },
            { label: domainLabel(domains, 'planstatus', plan.planstatus), variant: planstatusVariant(plan.planstatus) },
        ],
    };
}
